import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DashboardInfoContext, DashboardInfoPayload } from "../../../../../Context/dashboardContext";
import { UserContext, UserPayload } from "../../../../../Context/userContext";
import { AGENTS_ROUTE, EDIT_AGENT_QUERY_PARAM } from "../../../agents.constants";
import { useAgentsStore } from "../../../store/agents.store";
import { selectAgentDetail, selectAgentDetailLoading } from "../../../store/agentDetail/agentDetailSelectors";

export const useAgentDetails = () => {
    const [searchParams] = useSearchParams();
    const userId = searchParams.get(EDIT_AGENT_QUERY_PARAM);
    const navigate = useNavigate();
    const { setShowLoader } = useContext(UserContext) as UserPayload;
    const { setAgentFullName } = useContext(DashboardInfoContext) as DashboardInfoPayload;

    const data = useAgentsStore(selectAgentDetail);
    const loading = useAgentsStore(selectAgentDetailLoading);
    const fetchAgentDetails = useAgentsStore((state) => state.fetchAgentDetails);
    const fetchAllStates = useAgentsStore((state) => state.fetchAllStates);
    const resetAgentDetail = useAgentsStore((state) => state.resetAgentDetail);

    useEffect(() => {
        fetchAllStates();
    }, [fetchAllStates]);

    useEffect(() => {
        let cancelled = false;

        const resolveData = async () => {
            const parsedUserId = Number(userId);

            if (!userId || Number.isNaN(parsedUserId) || parsedUserId <= 0) {
                navigate(AGENTS_ROUTE, { replace: true });
                return;
            }

            const success = await fetchAgentDetails(parsedUserId, { setShowLoader });

            if (!cancelled && !success) {
                navigate(AGENTS_ROUTE, { replace: true });
            }
        };

        resolveData();

        return () => {
            cancelled = true;
            resetAgentDetail();
            setAgentFullName(null);
        };
    }, [userId, fetchAgentDetails, resetAgentDetail, navigate, setShowLoader, setAgentFullName]);

    useEffect(() => {
        if (!data?.personalInformation) {
            setAgentFullName(null);
            return;
        }

        const { firstName, lastName } = data.personalInformation;
        const displayName = `${firstName ?? ""} ${lastName ?? ""}`.trim();
        setAgentFullName(displayName || null);
    }, [data, setAgentFullName]);

    return { data, loading };
};
